import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import SearchBar from "component/searchBar/SearchBar";
import { useState, memo } from "react";
import MakeItem from "../accessories-make/MakeItem";
import styles from "../accessories-make/accessories-make.module.scss";
import { POPULAR_MAKES } from "../accessories-make/constant";
import MakeCard from "./MakeCard";

function AllMakes(props: any) {
  const {
    modelsWithUrl, h1, h2, labelKey, renderChildren,
  } = props;

  const [makeData, setMakeData] = useState(modelsWithUrl);
  const [activeChar, setActiveChar] = useState("");

  function defaultSearchValueHandler(searchPhrase: string, fromSearchBar?: boolean) {
    if (fromSearchBar) {
      setActiveChar("");
    }
    const updatedData = modelsWithUrl.filter((eachData) => eachData.make?.toLowerCase().startsWith(searchPhrase?.toLowerCase()));
    setMakeData(updatedData);
  }

  const letterArray = modelsWithUrl.map((eachData) => eachData.make[0]);
  const setLetter = Array.from(new Set(letterArray)).sort((a, b) => ((a > b) ? 1 : ((b > a) ? -1 : 0)));

  function alphabetClickHandler(c: string) {
    setActiveChar(c);
    if (c === "all") {
      setMakeData(modelsWithUrl);
    } else {
      defaultSearchValueHandler(c);
    }
  }

  return (
    <div className={styles.accessories_make}>

      <div className="accessories">

        <div className="row m-lr-0">

          <span className={styles.heading}>

            <h1>
              {h1}
            </h1>
          </span>

          <span className={styles.subheading} />
        </div>
        <div className="d-flex justify-content-between flex-wrap m-b-30" style={{ gap: "calc(2 * var(--safari-root-font, 10px))" }}>
          <PAText component="h2" fontSize={FONT_SIZE[5]} className="m-0">
            Popular Vehicle Makers
          </PAText>
          {/* <SearchBar
            placeholder="Filter Vehicle Makers"
            searchValueHandler={(p: string) => defaultSearchValueHandler(p, true)}
            hideResults
            hideHeading
            className={`${styles.searchbar} hidden-xs hidden-sm`}
            searchClassName={styles.search_order}
          /> */}

        </div>

        <div className={styles.each_make}>
          {POPULAR_MAKES.map((eachMake) => (
            <MakeItem {...eachMake} key={eachMake.url} />
          ))}
        </div>

        <div className={styles.alphabets_container}>
          <SearchBar
            placeholder="Filter Vehicle Makers"
            searchValueHandler={(p: string) => defaultSearchValueHandler(p, true)}
            hideResults
            hideHeading
            className={styles.searchbar}
            searchClassName={styles.search_order}
          />
          <div className={styles.alphabets}>
            <PAText component="h4" className={activeChar === "all" ? styles.active_char : ""} onClick={() => alphabetClickHandler("all")}>
              ALL
            </PAText>
            {setLetter.map((eachLetter) => (
              <PAText
                key={eachLetter}
                className={activeChar === eachLetter ? styles.active_char : ""}
                component="h4"
                onClick={() => alphabetClickHandler(eachLetter)}
              >
                {eachLetter}
              </PAText>
            ))}
          </div>

        </div>
        <div className={`section ${styles.section_makes_models}`}>

          <div className={styles.heading}>{h2}</div>
          {makeData && makeData.length > 0 && (
            <MakeCard
              renderChildren={renderChildren}
              labelKey={labelKey}
              data={makeData}
            />
          )}

        </div>
      </div>
    </div>
  );
}

export default memo(AllMakes);
